/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_PAYOUT_STATUS } from "../graphql";
import { VApplication } from "../../../application";
import { usePolicyId } from "../provider";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdatePayoutMethods extends IPluginMethodMap {
  getUpdatePayout(args: any): Promise<any>;
}

export interface UpdatePayoutProps {
  paymentStatus: string;
  amount: string;
  comment: string;
  receipt?: any;
}

export class UpdatePayoutService implements IAgentPlugin {
  readonly methods: IUpdatePayoutMethods;
  constructor() {
    this.methods = {
      getUpdatePayout: this.getUpdatePayout.bind(this),
    };
  }

  async getUpdatePayout(args: UpdatePayoutProps) {
    console.log(`payment update inside mutation`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_PAYOUT_STATUS,
          variables: {
            input: {
              ...args,
              paymentStatus: "FULLY_PAID",
              amount: parseFloat(args?.amount),
              receipt: Array.isArray(args?.receipt)
                ? args?.receipt[0]?.base64
                : null,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return res?.data?.updatePayoutStatus;
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
